import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=7b07896d&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=7b07896d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07896d",
  null
  
)

export default component.exports